import { Component, OnInit, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { Location, LocationStrategy, PathLocationStrategy, PopStateEvent } from '@angular/common';
import 'rxjs/add/operator/filter';
import { NavigationEnd, Router } from '@angular/router';
import { StorageService } from '../../shared/storage.service';
import { Subscription } from 'rxjs/Subscription';
import { FooterService } from '../../components/footer/footer.service';
import { filter } from 'rxjs/operators';
import { Gtag } from 'angular-gtag';

@Component({
    selector: 'app-user-layout',
    templateUrl: './user-layout.component.html',
    styleUrls: ['./user-layout.component.scss']
})
export class UserLayoutComponent implements OnInit {
    showFooter: boolean = true;
    colour;
    sidebarImage;

    constructor(
        public location: Location, 
        public router: Router,
        public storageService: StorageService, 
        private gtag: Gtag, 
        private footerService: FooterService
    ) {
        this.trackScreenView();
    }
    ngOnInit() {
        this.footerService.isFooterVisible$.subscribe(isVisible => {
            this.showFooter = isVisible;
        });
      this.trackScreenView();
    }

     trackScreenView() {
          this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
          ).subscribe((event: any) => {
            const screenName = event.urlAfterRedirects || 'home';
      
            this.gtag.event('screen_view', {
              'app_name': 'MyApp', 
              'screen_name': screenName
            });
      
            // console.log(`Screen View Logged: ${screenName}`);
          });
        }

}
